module.exports = __webpack_public_path__ + "img/blueDotAnimation.7854ba85.webp";